import './styles.less';
const PasswordTip = () => <div className="form-user-password-tip">
    <h5 className="h3">Tips och krav för starka lösenord</h5>
    <p className="f-500">
      Ett starkt lösenord är viktigt för att skydda din personliga information.
      Använd minst 8 tecken och max 17 tecken långt lösenord, med bokstäver
      (a-z, A-Z), siffror (0-9 ) och specialtecken  , ; . : - _ ' * ^ ~ ¨ ´ ` +
      ? \ = ( ) / &amp; % &curren; $ # &pound; &quot; @ ! &lt; &gt; |.
    </p>
    <p className="f-600 margin-v-2">
      <strong>Exempel: </strong>
      <span className="form-user-password-tip-password">
        m#P52s@ap$V
      </span>
    </p>
    <p className="f-400 fc-grey-500">
      Undvik att använda personlig information. Använd inte samma lösenord
      för flera konton. Ändra lösenordet regelbundet. Följ dessa tips för att
      skapa ett säkert lösenord.
    </p>
  </div>;
export default PasswordTip;